import {Component} from '@angular/core';
import {TechnicalAlertProvider} from '../../../../providers/technical-alert/technical-alert';
import {HistoryProvider} from '../../../../providers/history/history';
import {OpenCaseProvider} from '../../../../providers/open-case/open-case';

/**
 * Generated class for the QuitTechnicalComponent component.
 */
@Component({
  selector: 'quit-technical',
  templateUrl: 'quit-technical.html',
  styleUrls: ['./quit-technical.scss']
})
export class QuitTechnicalComponent {

  formdata: any = {
    reason: '',
    comment: ''
  };

  reasons: Array<any> = [
    {
      key: 'Abmeldung, TLN Außer Haus',
      value: 'Abmeldung, TLN Außer Haus'
    },
    {
      key: 'Anmeldung, TLN Zuhause',
      value: 'Anmeldung, TLN Zuhause'
    },
    {
      key: 'Benutzer Inaktiv',
      value: 'Benutzer Inaktiv'
    },
    {
      key: 'Inbetriebnahme',
      value: 'Inbetriebnahme'
    },
    {
      key: 'Probealarm',
      value: 'Probealarm'
    },
    {
      key: 'Technischer Alarm',
      value: 'Technischer Alarm'
    }
  ];

  constructor(public technicalAlertProvider: TechnicalAlertProvider, private historyProvider: HistoryProvider, private openCaseProvider: OpenCaseProvider) {
  }

  quit(form) {
    if (form.valid) {
      this.technicalAlertProvider.quit(this.formdata).then(() => {
        this.historyProvider.setHistoryData({
          dateTime: new Date().getTime(),
          code: '6666',
          desc: this.formdata.reason + ' ' + this.formdata.comment,
          editorPerson: this.technicalAlertProvider.api._user.profile.firstname + ' ' + this.technicalAlertProvider.api._user.profile.lastname
        });

        // this.openCaseProvider.openCaseData.splice(this.openCaseProvider.openCaseData.indexOf(this.technicalAlertProvider.activeAlertData), 1);
        this.openCaseProvider.tableData.remove(this.technicalAlertProvider.activeAlertData);

        this.technicalAlertProvider.getById(this.technicalAlertProvider.activeAlertData._id).subscribe((resp: any) => {
          this.technicalAlertProvider.activeAlertData = resp.data.data.data;
        });

      });
    }
  }

}